<template>
	<div
		class="player-data"
	>
		<div>
			<p class="info-key">
				{{ detailsLabels.nationality }}
			</p>
			<p class="info-value">
				{{ participantCountry || '-' }}
			</p>
		</div>
		<div>
			<p class="info-key">
				{{ detailsLabels.born }}
			</p>
			<p class="info-value">
				{{ participantAgeGroup || '-' }}
			</p>
		</div>
		<div>
			<p class="info-key">
				{{ detailsLabels.position }}
			</p>
			<p class="info-value">
				{{ participantPosition || '-' }}
			</p>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	props: {
		participant: {
			type:    Object,
			default: () => {},
		},
		detailsLabels: {
			type:    Object,
			default: () => ({
				nationality: $I18n.trans('commons.nationality'),
				born:        $I18n.trans('commons.born'),
				position:    $I18n.trans('commons.position'),
			}),
		},
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
			sportName:      'event/sportName',
		}),
		participantPosition() {
			const position = this.participant?.position?.name;
			if (!position) return;
			const result = this.$I18n.trans(`sports.${this.sportName}.positions.${position}`);
			if (!this.isMobileWebApp) return result;
			return result.split(' ').map(word => word[0].toUpperCase()).join('');
		},
		participantCountry() {
			if (!this.participant || !this.participant.country) {
				return null;
			}
			return this.participant.country.cca3;
		},
		participantAgeGroup() {
			if (!this.participant || !this.participant.birthdate) {
				return null;
			}
			return (new Date(this.participant.birthdate)).getFullYear();
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
	@import '@videotools/sass/_fonts';

	.player-data {
		display: flex;
		margin-top: 32px;

		div {
			margin-right: 30px;
		}
	}

	.info-key {
		color: var(--color-grey-300);
		font-weight: 400;
		@include text-sm-1;
	}

	.info-value {
		@include text-sm-2;
		font-weight: 500;
		color: var(--color-soft-white);

		body.-t-light & {
			color: var(--color-black);
		}
	}
</style>
